<template>
  <div
    class="mb-12 mt-12 flex h-[80vh] w-4/5 flex-col items-center justify-center rounded-2xl border-2 bg-white"
  >
    <slot />
  </div>
</template>
